import { Info, CheckCircle, AlertTriangle, XCircle } from 'lucide-react';

type MessageBarVariant = 'info' | 'success' | 'warning' | 'error';

interface MessageBarProps {
  variant?: MessageBarVariant;
  children: React.ReactNode;
  className?: string;
}

const variantStyles: Record<MessageBarVariant, { container: string; icon: React.ReactNode }> = {
  info: {
    container: 'bg-blue-50 border-blue-200 text-blue-800',
    icon: <Info className="h-4 w-4 text-blue-500 shrink-0" />,
  },
  success: {
    container: 'bg-green-50 border-green-200 text-green-800',
    icon: <CheckCircle className="h-4 w-4 text-green-500 shrink-0" />,
  },
  warning: {
    container: 'bg-amber-50 border-amber-200 text-amber-800',
    icon: <AlertTriangle className="h-4 w-4 text-amber-500 shrink-0" />,
  },
  error: {
    container: 'bg-red-50 border-red-200 text-red-800',
    icon: <XCircle className="h-4 w-4 text-red-500 shrink-0" />,
  },
};

export function MessageBar({ variant = 'info', children, className = '' }: MessageBarProps) {
  const styles = variantStyles[variant];
  return (
    <div className={`flex items-start gap-2.5 rounded-md border px-4 py-3 text-sm ${styles.container} ${className}`}>
      {styles.icon}
      <div className="flex-1">{children}</div>
    </div>
  );
}
